const chunkMapping = {
	"18303": [
		518303
	],
	"22942": [
		522942
	],
	"25721": [
		425721
	],
	"26073": [
		189354
	],
	"27570": [
		527570
	],
	"30998": [
		130998
	],
	"38858": [
		938858
	],
	"40145": [
		440145
	],
	"41049": [
		441049
	],
	"66412": [
		166412
	],
	"67501": [
		867501
	],
	"95446": [
		9771,
		132078,
		207566,
		347082,
		591757,
		657953,
		809557,
		825556,
		958949,
		999244
	]
};
const idToExternalAndNameMapping = {
	"9771": [
		"default",
		"./Pages",
		806820
	],
	"130998": [
		"default",
		"./translations/en-PS",
		235821
	],
	"132078": [
		"default",
		"./Reducers",
		806820
	],
	"166412": [
		"default",
		"./translations/fr_FR",
		235821
	],
	"189354": [
		"default",
		"./Pages",
		235821
	],
	"207566": [
		"default",
		"./Translations",
		235821
	],
	"347082": [
		"default",
		"./Sagas",
		951732
	],
	"425721": [
		"default",
		"./translations/en-PS",
		806820
	],
	"440145": [
		"default",
		"./translations/ja_JA",
		806820
	],
	"441049": [
		"default",
		"./translations/de_DE",
		806820
	],
	"518303": [
		"default",
		"./translations/fr_FR",
		806820
	],
	"522942": [
		"default",
		"./translations/ja_JA",
		235821
	],
	"527570": [
		"default",
		"./translations/de_DE",
		235821
	],
	"591757": [
		"default",
		"./Sagas",
		235821
	],
	"657953": [
		"default",
		"./Translations",
		806820
	],
	"809557": [
		"default",
		"./Pages",
		951732
	],
	"825556": [
		"default",
		"./Reducers",
		951732
	],
	"867501": [
		"default",
		"./translations/en-US",
		235821
	],
	"938858": [
		"default",
		"./translations/en-US",
		806820
	],
	"958949": [
		"default",
		"./Reducers",
		235821
	],
	"999244": [
		"default",
		"./Sagas",
		806820
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}